import { useCallback } from 'react';
import log from 'chameleon/ui-stack/utilities/log';

const useFetchDownloadPDF = ({
  client,
  assignmentId,
  assessmentId,
  masterSubjectId,
  setIsProcessing,
  query,
  getURLFromResponse,
}) => {
  const fetchAndDownloadPDF = useCallback(async () => {
    setIsProcessing(true);

    const variables = assignmentId
      ? { assignmentId, masterSubjectId }
      : { assessmentId, masterSubjectId };

    try {
      const response = await client.query({
        query,
        variables,
        fetchPolicy: 'network-only',
      });
      const responseFromUrl = getURLFromResponse(response);
      if (responseFromUrl) {
        window.location.href = responseFromUrl;
      }
    } catch (error) {
      log('error', error);
    } finally {
      setIsProcessing(false);
    }
  }, []);

  return fetchAndDownloadPDF;
};

export default useFetchDownloadPDF;
